import { Navigate } from "react-router-dom";

const PortalProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("client_token");
  
  if (!token) {
    return <Navigate to="/portal/login" replace />;
  }
  
  return children;
};

export default PortalProtectedRoute;
